import { type GetHookResponse } from '../hooks'
import { gameScorableKey } from '../keys'
import { useTantalimQuery } from '../query'
import { type GameScorableListInput, type GameScorableListSuccess, type ScorableMetricItem } from '@terros/common'

export const useScorables = (): GetHookResponse<ScorableMetricItem[]> => {
  return useTantalimQuery<GameScorableListInput, GameScorableListSuccess, ScorableMetricItem[]>({
    url: '/game/scorable/list',
    queryKey: gameScorableKey(),
    input: {},
    convertResponse: (data) => data.metrics,
  })
}
